import { Box, Button, Paper } from '@mui/material';
import { Link } from 'react-router';

import lockIcon from '../../assets/lock-icon-multicolor.svg';
import useStyles from './NoAccess.styles';

export const NoAccess = () => {
  const { classes } = useStyles();
  return (
    <Box className={classes.noAccess}>
      <Paper elevation={3} className={classes.paper}>
        <img
          src={lockIcon}
          alt="lock-icon"
          style={{ width: '250px', margin: '-50px 0' }}
        />
        <h1>Access to this page is restricted</h1>
        <p>
          Please check with the site admin if you believe this is a mistake.
        </p>
        <Button
          variant="contained"
          color="primary"
          href="/login"
          size="large"
          component={Link}
          to="/login"
        >
          Back to Login
        </Button>
      </Paper>
    </Box>
  );
};

export default NoAccess;
